module.exports = __webpack_public_path__ + "img/ewm11.7baba4dd.jpg";